import {
  TERMINAL_SUMMARY_FETCH_REQUEST,
  TERMINAL_SUMMARY_FETCH_REQUEST_SUCCESS,
  TERMINAL_SUMMARY_FETCH_REQUEST_FAILURE,
  TERMINAL_SUMMARY_CLEAN_REQUEST,
} from 'constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

const terminalSummaryReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case TERMINAL_SUMMARY_FETCH_REQUEST:
      return Object.assign({}, state, { loading: true });

    case TERMINAL_SUMMARY_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case TERMINAL_SUMMARY_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case TERMINAL_SUMMARY_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export default terminalSummaryReducer;
